import { render, staticRenderFns } from "./edit-attributes.vue?vue&type=template&id=213e667f&"
import script from "./edit-attributes.vue?vue&type=script&lang=js&"
export * from "./edit-attributes.vue?vue&type=script&lang=js&"
import style0 from "./edit-attributes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports